export const APP_VERSION = '0.1.0';
export const BUILD_TIME = '2026-06-01T11:38:07.357Z';
